import { use_slice_ui } from '@/hooks/store/use_slices';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { DTO__grid2d_cell_generation } from '@shared/dto/grid2d_cell/DTO__grid2d_cell_generation';
import { GRID2D_GALLERY_GENERATION__image_neigbours_row_item } from './GRID2D_GALLERY_GENERATION__image_neigbours_row_item';

interface PROPS {
  grid2d: DTO__grid2d_generation;
}

export function GRID2D_GALLERY_GENERATION__image_neigbours({ grid2d }: PROPS) {
  const { global__grid2d_gallery_cell_neigbours } = use_slice_ui(['global__grid2d_gallery_cell_neigbours']);

  function render_row(cells: DTO__grid2d_cell[], index_row: number) {
    return (
      <div key={`GRID2D_GALLERY__image_neigbours_${index_row}`} className="flex flex-row">
        {cells.map((cell, index_cell) => render_cell(cell, index_row, index_cell))}
      </div>
    );
  }

  function render_cell(cell: DTO__grid2d_cell, index_row: number, index_cell: number) {
    if (!(cell instanceof DTO__grid2d_cell_generation)) return null; //cached from previous render

    return <GRID2D_GALLERY_GENERATION__image_neigbours_row_item key={`GRID2D_GALLERY__image_neigbours_row_item_${cell.x}_${cell.y}`} {...{ cell, grid2d }} />;
  }

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
      <div className="flex flex-col ">{global__grid2d_gallery_cell_neigbours.map(render_row)}</div>
    </div>
  );
}
